import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listByProject = async (
  companyId: string,
  companyType: string,
  projectId: number
) =>
  post("projectService/dependency/listByProject", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
  });

export const addDependency = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/dependency/addDependency", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const removeDependency = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/dependency/removeDependency", {
    company_id: companyId,
    company_type: companyType,
    id,
  });
